module.exports = "https://static.wmbcdn.com/uniweb/images/500225a3336cc86aafbab9f596f19ab5.svg";